export const photoPanelConstants = { 
  ADD_PHOTO: 'ADD_PHOTO',
  UPDATE_PHOTO_DESCRIPTION: 'UPDATE_PHOTO_DESCRIPTION',
  DELETE_PHOTO: 'DELETE_PHOTO',
  RESET_PHOTOS: 'RESET_PHOTOS'
}
